import Timer from "@/utils/Timer";

export class StatusChecker {
    private static readonly threeMinutes: number = 1000 * 60 * 3;

    constructor() {
        this.processKey = new Date().getTime();
    }

    private timer: Timer = null;
    private processKey: number = null;
    private isDisposed: boolean = false;
    /**
     *
     * @param repeatableAction action to repeat, result goes in stopTrigger
     * @param stopTrigger should continue - return true, should stop - return false
     * @param timeoutMs ms
     * @returns void
     */
    async startStatusCheck(
        repeatableAction: Function,
        stopTrigger: Function,
        onStop: Function = null,
        onTimeout: Function = null,
        timeoutMs: number = StatusChecker.threeMinutes
    ) {
        this.resetTimer();
        this.timer = new Timer(timeoutMs);
        let checkResult: any = null;
        let shouldContinue = await stopTrigger(checkResult);
        while (!this.timer.isEnd && shouldContinue) {
            checkResult = await repeatableAction();
            await this.sleep(1000);
            if (this.isDisposed) return;
            shouldContinue = await stopTrigger(checkResult);
            if (!shouldContinue) {
                onStop?.();
            }
        }
        if (this.timer.isEnd) onTimeout?.();
        this.resetTimer();
    }

    resetTimer() {
        if (this.timer) this.timer.dispose();
    }
    dispose() {
        this.isDisposed = true;
        this.resetTimer();
    }

    private sleep(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
